import { sp } from "./constants";
import { Loc } from "./location";

export type WindDirection = "N" | "E" | "S" | "W" | "NE" | "NW" | "SE" | "SW";

// This is the format of the final data items
export interface SkiData {
  loc: Loc;
  distance: Distance;
  weather: Weather;
}

export class Distance {
  today: number;
  hours: number;
  cumulative: number;
  left: number;

  constructor(from: Loc, to: Loc, h: number, prevCumulative: number) {
    this.today = from.distance(to) / 1000;
    this.left = to.distance(sp) / 1000;
    this.hours = h;
    this.cumulative = prevCumulative + this.today;
  }

  get avgToday() {
    return this.hours > 0 ? this.today / this.hours : 0;
  }
}

export interface Weather {
  temp: number;
  wind: {
    speed: number;
    dir: WindDirection;
  };
}
